import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  layout: 'mix',
  contentWidth: 'Fixed',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'Đại học Hải Phòng',
  pwa: true,
  logo: 'https://dhhp.edu.vn/logo/logo-65.png',
  iconfontUrl: '',
  token: {
    sider: {
      colorMenuBackground: '#00387a',
      colorBgMenuItemHover: '#D02929',
      colorTextMenu: '#FFFFFF',
      colorTextMenuSelected: '#FFFFFF',
      colorTextMenuItemHover: '#FFFFFF',
      colorTextMenuActive: '#FFFFFF',
      colorBgMenuItemSelected: '#D02929',
      colorTextMenuSecondary: '#FFFFFF',
      colorTextMenuTitle: '#FFFFFF',
    }
  },
};

export default Settings;
